import styled from 'styled-components';

import { Value3, Value4, Small2, Value2 } from '../Text';
import { ButtonL } from '../Button';
import { Tooltip as BaseTooltip } from '../Tooltip';

const AlignWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const AlignLeftWrapper = styled(AlignWrapper)`
  justify-content: flex-start;
`;

export const AlignCenterWrapper = styled(AlignWrapper)`
  justify-content: center;
`;

export const AlignRightWrapper = styled(AlignWrapper)`
  justify-content: flex-end;
`;

export const MarketWrapper = styled.div<{ closed?: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  color: ${({ theme, closed }) => (closed ? theme.gray3 : theme.white)};
`;

export const MarketFlag = styled.img`
  width: 1.75rem;
  height: 1.75rem;
  border-radius: 0.7rem;
  margin-right: 0.44rem;
`;

export const LargeMarketFlag = styled(MarketFlag)`
  width: 2.125rem;
  height: 2.125rem;
`;

export const MarketLabel = styled(Value3)`
  color: unset;
  margin-right: 0.44rem;
`;

export const MarketSubInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.125rem;
  height: 100%;
  margin-left: 0.125rem;
`;

export const MarketAddress = styled(Small2)`
  color: ${({ theme }) => theme.gray4};
  text-decoration: none;
  :hover {
    text-decoration: underline;
  }
`;

export const DollarValue = styled(Value2)`
  color: ${({ value, theme }) => (value === null || value === 0 ? theme.gray4 : theme.white)};
`;

export const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 1rem;
`;

export const ActionButton = styled(ButtonL)`
  flex: 1;
`;

export const CondensedRowContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 1.5rem 1.25rem;

  &:not(:last-child) {
    border-bottom: 1px solid ${({ theme }) => theme.bg5};
  }
`;

export const CondensedRowHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 1rem;
`;

export const CondensedMarketFlag = styled(MarketFlag)`
  width: 1.25rem;
  height: 1.25rem;
`;

export const CondensedValuesContainer = styled.div`
  padding: 0.5rem 0rem;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-bottom: 0.5rem;
`;

export const CondensedValue = styled.div`
  box-sizing: border-box;
  width: 48%;
  padding-bottom: 0.75rem;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
`;

export const TextValue = styled(Value4)<{ value?: number | null; closed?: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  color: ${({ theme, value, closed }) => {
    if (closed) {
      return theme.gray3;
    }
    if (value === undefined || value === 0) {
      return theme.white;
    }
    if (value === null) {
      return theme.gray3;
    }
    if (value < 0) {
      return theme.red;
    }
    return theme.green;
  }};
  @media only screen and (max-width: ${({ theme }) => theme.tablet}) {
    font-weight: 600;
  }
`;

export const Tooltip = styled(BaseTooltip)`
  margin-left: 0.5rem;
`;

export const Row = styled.tr<{ hoverable: boolean }>`
  :hover {
    background: ${({ theme, hoverable }) => (hoverable ? theme.bg4 : 'none')};
    cursor: ${({ hoverable }) => (hoverable ? 'pointer' : 'inherit')};
  }
`;
